import {PageService, AuthService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
  name: 'club-loyalty',

  mixins: [MetaData],
  
  data(){
    return {
      article: [],
      loading: true,
      user:{},
      isGuest: true,
      loadingResendActivation: false
    }
  },

  methods: {
    getContent() {
      this.loading = true;
      Promise.all([PageService.getGeneralPage("Movie_Cards"), AuthService.user(), AuthService.isGuestUser()]).then(([article,user, guest])=> {
        this.user = user
        this.article = article;
        this.loading = false;
        this.isGuest = guest;
        // console.log(this.user)
      });
    },

    resendVerification(){
      // console.log("resend activation link")
          this.loadingResendActivation = true
          AuthService.resendActivation().then(()=> {
            this.loadingResendActivation = false
              // this.$emit('change', true);
              // this.showUserActivation = false;
              // this.activationLoading = false;
          });
      },
  },

  created(){
    // console.log("club loyalty page")
    this.getContent();
    this.metaTitle = 'Join our Movie Club | Enjoy Discount Movie Tickets '
    this.metaDescription = 'Want to watch more movies more often? SK CLUB rolls out the red carpet for those that love to experience movies the best way possible! As a SK CLUB member you unlock Value Rewards, Points Rewards and Access Rewards.'
    this.metaImage = '/static/img/sk-logo.png'

  },

  mounted() {
    window.scroll({top: 0, left: 0})
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/club-loyalty/club-loyalty.js